import {faker}  from "@faker-js/faker";
import { INTEGRATION_TYPES } from "../../utils/app-constants.json";
import moment from "moment";
import { TERRAFORM_COMPLETED_BP_ID } from "../factories/blueprints";
import { activeOrganization } from "../multi-tenancy/multi-tenancy";

var createdDate = moment();
createdDate = moment.utc(createdDate.subtract(1, "days"));

var pendingProjectDate = moment();
pendingProjectDate = moment.utc(pendingProjectDate.subtract(2, "minutes"));

const organization = [
  {
    ID: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    Name: activeOrganization.Name,
    Description: activeOrganization.Description, 
  },
];

const os = [
  "AMAZON_LINUX",
  "AMAZON_LINUX_2",
  "REDHAT_ENTERPRISE_LINUX",
  "SUSE",
  "CENTOS",
  "UBUNTU",
  "WINDOWS",
  "Others",
];

const osPlatform = [
  {
    os: "AMAZON_LINUX",
    platform: "LINUX",
  },
  {
    os: "AMAZON_LINUX_2",
    platform: "LINUX",
  },
  {
    os: "REDHAT_ENTERPRISE_LINUX",
    platform: "LINUX",
  },
  {
    os: "SUSE",
    platform: "LINUX",
  },
  {
    os: "CENTOS",
    platform: "LINUX",
  },
  {
    os: "UBUNTU",
    platform: "LINUX",
  },
  {
    os: "WINDOWS",
    platform: "WINDOWS",
  },
];
const accounts1 = [
  {
    AccountName: "Protein Research Lab",
    AccountNumber: "904433914959",
    AccountStatus: "Active",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    RegionCount: 3,
    RegionCode: "us-east-1",
    Regions: [
      {
        Status: "CONNECTED",
        RegionCode: "us-east-1",
        RegionName: "US East (N. Virginia)",
      },
    ],
  },
  {
    AccountName: "Protein Research DevTest",
    AccountNumber: "591335929153",
    AccountStatus: "Active",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
  },
  {
    AccountName: "Cyber Research And Operations",
    AccountNumber: "897930493710",
    AccountStatus: "Active",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
  },

];
const accounts2 = [
  {
    AccountName: "ELabFTW Production",
    AccountNumber: "500608819332",
    AccountStatus: "Active",
    Status: "CONNECTED",
    Departments: ["72ka91b7-551f-4d35-a113-b37fcd840a71"],
    RegionCount: 2,
    RegionCode: "us-east-2",
    Regions: [
      {
        Status: "CONNECTED",
        RegionCode: "us-east-1",
        RegionName: "US East (N. Virginia)",
      },
    ],
  },
  {
    AccountName: "ELabFTW DevTest",
    AccountNumber: "263404293554",
    AccountStatus: "Active",
    Status: "CONNECTED",
    Departments: ["72ka91b7-551f-4d35-a113-b37fcd840a71"],
    Regions: [
      {
        Status: "CONNECTED",
        RegionCode: "us-east-2",
        RegionName: "US East (Ohio)",
      },
    ],
  },
];
const accounts3 = [
  {
    AccountName: "GeoSpatial Internship Account",
    AccountNumber: "932383143047",
    AccountStatus: "Active",
    Status: "CONNECTED",
    Departments: ["31rba91b7-551f-4d35-a113-b37fcd840a71"],
    RegionCount: 4,
    RegionCode: "us-east-1",
    Regions: [
      {
        Status: "CONNECTED",
        RegionCode: "us-west-2",
        RegionName: "US West (Oregon)",
      },
    ],
  },
  {
    AccountName: "GeoSpatial Lab DevTest",
    AccountNumber: "452309014589",
    AccountStatus: "Active",
    Status: "CONNECTED",
    Departments: ["31rba91b7-551f-4d35-a113-b37fcd840a71"],
    Regions: [
      {
        Status: "CONNECTED",
        RegionCode: "ap-southeast-3",
        RegionName: "Asia Pacific (Jakarta)",
      },
    ],
  },
  {
    AccountName: "GeoSpatial Lab account",
    AccountNumber: "328189687004",
    AccountStatus: "Active",
    Departments: ["31rba91b7-551f-4d35-a113-b37fcd840a71"],
    Regions: [
      {
        Status: "CONNECTED",
        RegionCode: "us-west-2",
        RegionName: "US West (Oregon)",
      },
    ],
  },
];
const departments = [
  {
    Description: "Predicting protein structures at scale",
    ID: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Name: "Protein Research",
    OrganizationId: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    CreatedBy: 1,
    CreatedOn: createdDate,
    cost: "5034.22",
    currency: "USD",
    DepartmentCode: "ProteinResearch",
    Metadata: {
      PointPerson: "John Foltz",
      Owner: "John Foltz",
      GroupName: "Molecular & Cellular Biology",
      BudgetExist: true,
      BudgetValue: 15000,
    },
    Services: {
      Blueprints: [
        "338f3c2d-54d7-5c30-854d-a0c6098bf94a",
        "ffd4831f-ace2-5a7c-8a0e-dc3bbf77bf67",
        TERRAFORM_COMPLETED_BP_ID,
      ],
      Other: "AWS Compute Custom",
    },
    Accounts: accounts1,
    Users: 3,
    Applications: 5,
    PotentialSavings: "80",
  },
  {
    Description: "Electronic lab notebook for Digisweep",
    ID: "72ka91b7-551f-4d35-a113-b37fcd840a71",
    Name: "ElabFTW",
    OrganizationId: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    CreatedBy: 1,
    CreatedOn: createdDate,
    cost: "3263.43",
    currency: "USD",
    DepartmentCode: "ElabFTW",
    Metadata: {
      PointPerson: "Dev Singh",
      Owner: "Dev Singh",
      GroupName: "Research & Outreach",
      BudgetExist: true,
      BudgetValue: 5000,
    },
    Services: {
      Blueprints: [
        "df8a21c3-f645-569e-b92d-8f812bb4df9d",
        "867cc57f-a918-51a0-b386-0c69f68b73ce",
      ],
      Other: "AWS Compute Custom",
    },
    Accounts: accounts2,
    Users: 6,
    Applications: 2,
    PotentialSavings: "2960",
  },
  {
    Description: "Innovation in Geospatial science and technology",
    ID: "31rba91b7-551f-4d35-a113-b37fcd840a71",
    Name: "Geospatial AI",
    OrganizationId: "e514d2d2-dcb8-4daf-9a7d-93feb7eedf3c",
    CreatedBy: 1,
    CreatedOn: createdDate,
    cost: "4823",
    currency: "USD",
    DepartmentCode: "Geospatial",
    Metadata: {
      PointPerson: "Jackie Norman",
      Owner: "Jackie Norman",
      GroupName: "Environmental Engineering",
      BudgetExist: true,
      BudgetValue: 10200,
    },
    Services: {
      Blueprints: [
        "0d456be2-7762-5fde-a5f5-dd6aac168778",
        "7d462c6c-1118-58c0-95f3-c92654858bd9",
        "6fde1654-cd1c-5989-aee5-924c3f3f24a8",
      ],
      Other: "AWS Compute Custom",
    },
    Accounts: accounts3,
    Users: 3,
    Applications: 5,
    PotentialSavings: "20",
  },
];

export const TERRAFORM_ENV_ID = "14a6531d-9101-4c87-983b-146a89eabc5b-879h2rf";

const applications1 = [
  {
    ID: "1",
    Name: "Protein-Research-Core-Environment",
    environment: "Prod",
    Description: "AlphaFold Protein Research Infrastructure Core environment",
    EnvironmentId: "14a6531d-9101-4c87-983b-146a89eabc5b",
    EnvironmentName: "Prod",
    TotalCost: "1800",
    Currency: "USD",
    Dimension: "Blueprint",
    SecurityBotOpenIssues: 25,
    ComplianceBotOpenIssues: 3,
  },
  {
    ID: "2",
    Name: "Protein-Research-Automated-Analytics",
    environment: "Prod",
    Description: "AlphaFold Batch Job Automation",
    EnvironmentId: "4674bc39-c966-4a74-81f1-84723aaf6702",
    EnvironmentName: "Prod",
    TotalCost: "840",
    Currency: "USD",
    Dimension: "Tags",
    SecurityBotOpenIssues: 10,
    ComplianceBotOpenIssues: 1,
  },
  {
    ID: "3",
    Name: "Protein-Research-Notebook-1",
    environment: "Test",
    Description: "Research Notebook 1",
    EnvironmentId: "fb7c577c-26cc-4774-9b59-1beba2bb0987",
    EnvironmentName: "Test",
    TotalCost: "1250",
    Currency: "USD",
    Dimension: "Blueprint",
    SecurityBotOpenIssues: 15,
    ComplianceBotOpenIssues: 0,
  },
  {
    ID: "4",
    Name: "Protein-Research-Notebook-2",
    environment: "Test",
    Description: "Research Notebook 2",
    EnvironmentId: "a5de5262-c14c-4234-aa69-3ad21d57f803",
    EnvironmentName: "Test",
    TotalCost: "970",
    Currency: "USD",
    Dimension: "Blueprint",
    SecurityBotOpenIssues: 45,
    ComplianceBotOpenIssues: 8,
  },
  {
    ID: TERRAFORM_ENV_ID,
    Name: "Terraform-Protein-Research",
    environment: "Prod",
    Description:
      "Terraform Protein Research Infrastructure Core environment",
    EnvironmentId: TERRAFORM_ENV_ID,
    EnvironmentName: "Terraform Prod",
    TotalCost: "1200",
    Currency: "USD",
    Dimension: "Blueprint",
    SecurityBotOpenIssues: 25,
    ComplianceBotOpenIssues: 3,
  },
];

const applications2 = [
  {
    ID: "5",
    Name: "ElabFTW-App-Prod",
    environment: "Prod",
    Description: "ElabFTW Production",
    EnvironmentId: "14a6531d-9101-4c87-983b-146a89eabc5b",
    EnvironmentName: "Prod",
    TotalCost: "1530",
    Currency: "USD",
    RegionCount: 4,
    Dimension: "Blueprint",
    SecurityBotOpenIssues: 0,
    ComplianceBotOpenIssues: 0,
  },
  {
    ID: "6",
    Name: "ElabFTW-App-Test",
    environment: "Test",
    Description: "Sales-App-Test",
    EnvironmentId: "31dfdce5-899e-4736-bab2-1e79816337dd",
    EnvironmentName: "Test",
    TotalCost: "1733.43",
    Currency: "USD",
    Dimension: "Blueprint",
    SecurityBotOpenIssues: 20,
    ComplianceBotOpenIssues: 10,
  },
];

const applications3 = [
  {
    ID: "7",
    Name: "Geospatial AI-App-dev",
    environment: "Dev",
    Description: "Geospatial AI Development",
    EnvironmentId: "5bc3bbf3-72d3-4c19-8939-36b5968dad0b",
    EnvironmentName: "Development",
    TotalCost: "500",
    Currency: "USD",
    Dimension: "Blueprint",
    SecurityBotOpenIssues: 20,
    ComplianceBotOpenIssues: 6,
  },
  {
    ID: "8",
    Name: "Geospatial AI-App-Staging",
    environment: "Staging",
    Description: "Geospatial AI Staging",
    EnvironmentId: "02ff981f-b02f-404c-a9f7-3cd95f3d46d3",
    EnvironmentName: "Staging",
    TotalCost: "1500",
    Currency: "USD",
    Dimension: "CFN",
    SecurityBotOpenIssues: 0,
    ComplianceBotOpenIssues: 7,
  },
  {
    ID: "9",
    Name: "Geospatial AI-App-Prod",
    environment: "Prod",
    Description: "Geospatial AI Production",
    EnvironmentId: "5021cb7d-cff6-4fc5-853e-783fc024c3c4",
    EnvironmentName: "Production",
    TotalCost: "2823",
    Currency: "USD",
    Dimension: "CFN",
    SecurityBotOpenIssues: 0,
    ComplianceBotOpenIssues: 5,
  },
];

const standbyAccounts = [
  {
    AccountName: "Acme Inc Master AWS Account",
    AccountNumber: "181570489212",
    AccountStatus: "Active",
    Departments: ["UNASSIGNED"],
    AccountType: "MANAGEMENT",
  },
  {
    AccountName: "Core AWS Account",
    AccountNumber: "452309324589",
    AccountStatus: "Active",
    Departments: ["UNASSIGNED"],
  },
  {
    AccountName: "Central Logging Account",
    AccountNumber: "328189647004",
    AccountStatus: "Active",
    Departments: ["UNASSIGNED"],
  },
  {
    AccountName: "Shared Services Account",
    AccountNumber: "964659314314",
    AccountStatus: "Active",
    Departments: ["UNASSIGNED"],
  },
  {
    AccountName: "Security Account",
    AccountNumber: "612020440690",
    AccountStatus: "Active",
    Departments: ["UNASSIGNED"],
    AccountType: "MEMBER",
    ParentAccountNumber: "181570489212",
  },
  {
    AccountName: "Sandbox Account",
    AccountNumber: "700953207471",
    AccountStatus: "Active",
    Departments: ["UNASSIGNED"],
    AccountType: "MEMBER",
    ParentAccountNumber: "181570489212",
  },
];

const serverGroups = [
  {
    Name: "HR-App-Prod-Servers",
    Description: "HR App group (Production)",
  },
  {
    Name: "Sales-App-Prod-Servers",
    Description: "Sales App group (Production)",
  },
  {
    Name: "Sales-App-Staging-Servers",
    Description: "Sales App group (Staging)",
  },
  {
    Name: "Sales-App-Test-Servers",
    Description: "Sales App group (Test)",
  },
  {
    Name: "Inventory-App-Prod--Servers",
    Description: "Inventory App group (Production)",
  },
  {
    Name: "Inventory-App-Staging",
    Description: "Invetory App group (Staging)",
  },
  {
    Name: "Inventory-App-Test-Servers",
    Description: "Invetory App group (Test)",
  },
  {
    Name: "Invoicing-App-Prod-Servers",
    Description: "Invoicing App group (Production)",
  },
  {
    Name: "Invoicing-App-Staging-Servers",
    Description: "Invoicing App group (Staging)",
  },
  {
    Name: "Invoicing-App-Test-Servers",
    Description: "Invoicing App group (Test)",
  },
];

const allIntegrations = {
  [INTEGRATION_TYPES.SLACK]: [
    {
      ChannelName: "Central_IT_App_Health_Channel",
      Description: "IT Application Health Channel",
    },
    {
      ChannelName: "Central_IT_DevOps_Channel",
      Description: "Deployment and Operations Channel",
    },
    {
      ChannelName: "Central_IT_Security_Channel",
      Description: "Security Discussions Channel",
    },
  ],
  [INTEGRATION_TYPES.SNS]: [
    {
      ChannelName: "Central_IT_Security_Alerts",
      Description: "Dedicated notifications for Security Alerts",
    },
    {
      ChannelName: "Elastic_Search_App_Status_Changes",
      Description: "Elastic Search App Team Notifications",
    },
    {
      ChannelName: "Data_Hub_App_Status_Changes",
      Description: "Data Hub App Team Notifications",
    },
  ],
  [INTEGRATION_TYPES.MICROSOFT_TEAMS]: [
    {
      ChannelName: "Central_IT_Security_Alerts",
      Description: "Dedicated notifications for Security Alerts",
    },
  ],
  [INTEGRATION_TYPES.JIRA_ISSUE]: [
    {
      ChannelName: "Central_IT_Security_Alerts",
      Description: "Dedicated notifications for Security Alerts",
    },
  ],
  [INTEGRATION_TYPES.PAGERDUTY_INCIDENT]: [
    {
      ChannelName: "Central_IT_Security_Alerts",
      Description: "Dedicated notifications for Security Alerts",
    },
  ],
  [INTEGRATION_TYPES.SQS]: [
    {
      ChannelName: "Central_IT_Security_Alerts",
      Description: "Dedicated notifications for Security Alerts",
    },
  ],
};

const patchPolicies = [
  {
    policyName: "Zero-Day-Vulnerability-Windows-Server-Policy",
    Description: "Zero day vulnerabilities for Windows Server",
    operatingSystem: "WINDOWS",
  },
  {
    policyName: "Zero-Day-Vulnerability-AmazonLinux-Server-Policy",
    Description: "Zero day vulnerabilities for Amzon Linux 1, Amzon Linux 2",
    operatingSystem: "AMAZON_LINUX",
  },
  {
    policyName: "Zero-Day-Vulnerability-RHEL-Server-Policy",
    Description: "Zero day vulnerabilities for RHEL",
    operatingSystem: "REDHAT_ENTERPRISE_LINUX",
  },
  {
    policyName: "Zero-Day-Vulnerability-Ubuntu-Server-Policy",
    Description: "Zero day vulnerabilities for Ubuntu",
    operatingSystem: "UBUNTU",
  },
  {
    policyName: "Zero-Day-Vulnerability-Centos-Server-Policy	",
    Description: "Zero day vulnerabilities for Cent OS",
    operatingSystem: "CENTOS",
  },
  {
    policyName: "Zero-Day-Vulnerability-SUSE-Server-Policy",
    Description: "Zero day vulnerabilities for SUSE",
    operatingSystem: "SUSE",
  },
  {
    policyName: "Meltdown-and-Spectre-Windows-Server-Policy",
    Description: "Meltdown and Spectre policy for Windows Server",
    operatingSystem: "WINDOWS	",
  },
  {
    policyName: "Meltdown-and-Spectre-RHEL-Server-Policy",
    Description: "Meltdown and Spectre policy for RHEL",
    operatingSystem: "REDHAT_ENTERPRISE_LINUX",
  },
];

const allApplications = () => {
  const allApps = [];
  applications1.forEach((app) => {
    app.DepartmentId = departments[0].ID;
    app.DepartmentName = departments[0].Name;
    app.Metadata = {
      Scope: {
        Accounts: accounts1,
      },
    };
    allApps.push(app);
  });
  applications2.forEach((app) => {
    app.DepartmentId = departments[1].ID;
    app.DepartmentName = departments[1].Name;
    app.Metadata = {
      Scope: {
        Accounts: accounts2,
      },
    };
    allApps.push(app);
  });
  applications3.forEach((app) => {
    app.DepartmentId = departments[2].ID;
    app.DepartmentName = departments[2].Name;
    app.Metadata = {
      Scope: {
        Accounts: accounts3,
      },
    };
    allApps.push(app);
  });
  let proccessedApps = [];
  allApps.forEach((app, index) => {
    app.Status = "ACTIVE";
    app.ApplicationStatus = "ACTIVE";
    app.CreatedOn = faker.date.past();
    app.CreatedBy = "Cloud Admin";
    app.Role = "ELSCloudformationRole";
    app.PermissionCFNURL = "Default";
    app.AlertCount = [0, 4, 6].includes(index)
      ? faker.number.int({ min: 6, max: 10 })
      : 0;

    proccessedApps.push(app);
  });
  return proccessedApps;
};

const projectRequests = [
  {
    ID: "9aba91b7-551f-4d35-a113-b37fcd840a71",
    Description: "HPC for Genome-Wide Analysis Study",
    Name: "Genome Research",
    CreatedBy: 6,
    CreatedAt: pendingProjectDate,
    State: "Pending",
    Reviewer: "e293de2d-ca8c-47bf-a4c7-9e72ac944b40",
    Metadata: {
      PointPerson: "Cassandra Hildebrandt",
      Owner: "Cassandra Hildebrandt",
      GroupName: "Genome Sciences",
      BudgetExist: true,
      BudgetValue: 8000,
      MeetingScheduledOn: "Feb 3rd 2022",
      MeetingScheduledWith: 8,
      MeetingId: "efd3de2d-ca8c-47bf-a4c7-9e72ac944b40",
    },
    Services: {
      Blueprints: [
        "7a8e592d-5e37-47ac-877d-c44a817dafc4",
        "2ed84a19-39ef-56c7-9ded-2fb5ed877c6d",
      ],
      Other: "Custom Blueprint",
    },
    Preference: {
      SecurityBot: true,
      ComplianceBot: true,
      CostOptimizationCheck: true,
      WeeklyCostSummaryReport: true,
    },
  },
  {
    ID: "bb8a91b7-551f-4d35-a113-b37fcd840a71",
    Description: "Applied Analysis on theoretical linguisitics ",
    Name: "Linguistic Cues",
    CreatedBy: 6,
    CreatedAt: createdDate,
    State: "WITHDRAWN",
    Reviewer: "e293de2d-ca8c-47bf-a4c7-9e72ac944b40",
    Metadata: {
      PointPerson: "Johnny Delgato",
      Owner: "Michael Keters",
      GroupName: "Languages & Literature",
      BudgetExist: true,
      BudgetValue: 8000,
      MeetingScheduledOn: "Feb 7thd 2022",
      MeetingScheduledWith: 8,
      MeetingId: "efd3de2d-ca8c-47bf-a4c7-9e72ac944b40",
    },
    Services: {
      Blueprints: [
        "6e60bf60-5c08-5a60-92aa-b9bc343343fb",
        "6fde1654-cd1c-5989-aee5-924c3f3f24a8",
      ],
      Other: "AWS Compute Custom",
    },
    Preference: {
      SecurityBot: true,
      ComplianceBot: true,
      CostOptimizationCheck: true,
      WeeklyCostSummaryReport: true,
    },
  },
  {
    ID: "bb8a81b7-551f-4d35-a113-b37fcd840a71",
    Description: "Data Mining patterns and Exploration Research",
    Name: "DataMining Research",
    CreatedBy: 6,
    CreatedAt: createdDate,
    State: "REJECTED",
    Reviewer: "e293de2d-ca8c-47bf-a4c7-9e72ac944b40",
    Metadata: {
      PointPerson: "Johnny Delgato",
      Owner: "Michael Keters",
      GroupName: "Fall Season 2022",
      BudgetExist: true,
      BudgetValue: 8000,
      MeetingScheduledOn: "Feb 7thd 2022",
      MeetingScheduledWith: 8,
      MeetingId: "efd3de2d-ca8c-47bf-a4c7-9e72ac944b40",
    },
    Services: {
      Blueprints: [
        "ab719e5e-31aa-58e9-843c-9f3a9f9dbc88",
        "bbe4019e-158f-5d37-ba55-8a0fb0836af4",
      ],
      Other: "AWS Compute Custom",
    },
    Preference: {
      SecurityBot: true,
      ComplianceBot: true,
      CostOptimizationCheck: true,
      WeeklyCostSummaryReport: true,
    },
    StateChangeMessage: "Incorrect services selected",
  },
];

const defaultValues = () => {
  return {
    organization,
    departments,
    allApplications: allApplications(),
    applications1,
    applications2,
    applications3,
    serverGroups,
    accounts1,
    accounts2,
    accounts3,
    allIntegrations,
    patchPolicies,
    os,
    osPlatform,
    standbyAccounts,
    projectRequests,
  };
};

export default defaultValues;
